export const trendConfig = {
  decrease: {
    color: "#15b471",
    icon: "fa-solid fa-arrow-trend-down",
    name: "Decreasing",
  },

  increase: {
    color: "#ff4500",
    icon: "fa-solid fa-arrow-trend-up",
    name: "Increasing",
  },

  default: {
    color: "#808080",
    icon: "fa-solid fa-minus",
    name: "No Change",
  },
};
